module.exports = {"360403001":"甘棠街道","360403002":"湓浦街道","360403003":"人民路街道","360403004":"白水湖街道","360403005":"金鸡坡街道","360403091":"向阳街道（九江经济技术开发区）","360403092":"滨兴街道（九江经济技术开发区）","360403400":"茅山头企业集团（九江经济技术开发区）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360403.json
// module id = 1168
// module chunks = 0